"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonKit = _interopRequireDefault(require("../button-kit"));
var _closeButton = _interopRequireDefault(require("../close-button"));
var _imageLoader = _interopRequireDefault(require("../image-loader"));
var _modalProvider = require("../modal-provider");
var _theme = require("../theme");
require("./dialog.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable complexity */
/**
 * Dialog is a modal dialog that includes pre-styled buttons. To create a custom solution for the buttons, pass `renderButtons` as false, and include your buttons as part of the children passed to Dialog.
 *
 * Unless the `renderButtons` prop is set to false, a `confirmText` will need to be provided to render a confirm button.
 *
 * An `onCancel` event should always be provided to enable the option to close the dialog with the `escape` key and/or the cancel and exit buttons.
 *
 * To get exit animation, the content/children of Dialog should be removed before the Dialog itself.
 * If the Dialog is able to be mounted at all times, entrance and exit animations will always work.
 *
 * The Dialog will respond to a theme passed from a ThemeProvider.Provider that wraps around the Dialog. Refer to the [Theme documentation](/components/theme-context) for more details.
 */
var Dialog = function Dialog(_ref) {
  var _ref$buttonContainerC = _ref.buttonContainerClassName,
    buttonContainerClassName = _ref$buttonContainerC === void 0 ? '' : _ref$buttonContainerC,
    cancelButtonProps = _ref.cancelButtonProps,
    cancelText = _ref.cancelText,
    children = _ref.children,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? '' : _ref$closeButtonAriaL,
    _ref$confirmButtonOnl = _ref.confirmButtonOnly,
    confirmButtonOnly = _ref$confirmButtonOnl === void 0 ? false : _ref$confirmButtonOnl,
    confirmButtonProps = _ref.confirmButtonProps,
    confirmText = _ref.confirmText,
    _ref$contentContainer = _ref.contentContainerProps,
    contentContainerProps = _ref$contentContainer === void 0 ? {} : _ref$contentContainer,
    _ref$dialogContainerP = _ref.dialogContainerProps,
    dialogContainerProps = _ref$dialogContainerP === void 0 ? {} : _ref$dialogContainerP,
    imageAltText = _ref.imageAltText,
    imageLoaderProps = _ref.imageLoaderProps,
    imageUrl = _ref.imageUrl,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
    _ref$renderButtons = _ref.renderButtons,
    renderButtons = _ref$renderButtons === void 0 ? true : _ref$renderButtons,
    _ref$renderCloseButto = _ref.renderCloseButton,
    renderCloseButton = _ref$renderCloseButto === void 0 ? false : _ref$renderCloseButto,
    _ref$rootContainerPro = _ref.rootContainerProps,
    rootContainerProps = _ref$rootContainerPro === void 0 ? {} : _ref$rootContainerPro;
  var _ref2 = (0, _react.useContext)(_modalProvider.ModalContext) || {},
    _ref2$closeModal = _ref2.closeModal,
    closeModal = _ref2$closeModal === void 0 ? function () {} : _ref2$closeModal;
  var confirmHandler = function confirmHandler() {
    closeModal();
    onConfirm();
  };
  var cancelHandler = function cancelHandler() {
    closeModal();
    onCancel();
  };
  var buttonKitCancelButton = !confirmButtonOnly ? {
    cancelText: cancelText,
    onCancel: cancelHandler,
    cancelProps: cancelButtonProps
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: "sb-dialog--container"
    }, rootContainerProps), /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: (0, _classnames["default"])('sb-dialog--content mx3 lg-mx0', {
        'bg-houseGreen color-textWhite': theme === _theme.themes.dark
      })
    }, dialogContainerProps), renderCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
      alignment: "right",
      ariaLabel: closeButtonAriaLabel,
      className: "m3",
      highContrast: true,
      onClick: cancelHandler
    }), imageUrl && /*#__PURE__*/_react["default"].createElement(_imageLoader["default"], _extends({
      alt: imageAltText,
      className: "sb-dialog--dialogImage size12of12",
      src: imageUrl
    }, imageLoaderProps)), /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: "sb-dialog--contentBody"
    }, contentContainerProps), children, renderButtons && confirmText && /*#__PURE__*/_react["default"].createElement(_buttonKit["default"], _extends({
      className: buttonContainerClassName,
      confirmProps: confirmButtonProps,
      confirmText: confirmText,
      onConfirm: confirmHandler
    }, buttonKitCancelButton)))));
  });
};
Dialog.displayName = 'Dialog';
Dialog.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Overwrites default buttonContainer className.
   */
  buttonContainerClassName: _propTypes["default"].string,
  /**
   * Additional props passed to cancel button
   */
  cancelButtonProps: _propTypes["default"].object,
  /**
   * The cancel button's text. Can be an element.
   */
  cancelText: _propTypes["default"].node,
  /**
   * Dialog content
   */
  children: _propTypes["default"].any,
  /**
   * A string of text that acts as the aria label for the close button. `renderCloseButton` must be set to `true`.
   */
  closeButtonAriaLabel: _propTypes["default"].string,
  /**
   * A boolean indicating whether only a confirm button is desired,
   * instead of both a confirm and cancel button.
   */
  confirmButtonOnly: _propTypes["default"].bool,
  /*
   * Additional props passed to confirm button
   */
  confirmButtonProps: _propTypes["default"].object,
  /**
   * The confirm button's text. Can be an element.
   */
  confirmText: _propTypes["default"].node,
  /**
   * Props for the content container. This surrounds the children and `ButtonKit` of the dialog
   */
  contentContainerProps: _propTypes["default"].object,
  /**
   * Props for the surrounding dialog container.
   */
  dialogContainerProps: _propTypes["default"].object,
  /**
   * The text for the alt attribute on an image
   */
  imageAltText: _propTypes["default"].string,
  /**
   * Optional image loader props. Refer to the [ImageLoader](/components/images) documentation for props to include here.
   */
  imageLoaderProps: _propTypes["default"].object,
  /**
   * The optional url of image on top of the dialog
   */
  imageUrl: _propTypes["default"].string,
  /**
   * A callback for when a dialog is cancelled (either by the default cancel button or by a direct call in a child function component).
   */
  onCancel: _propTypes["default"].func,
  /**
   * A callback for when a dialog is confirmed (either by the default confirm button or by a direct call in a child function component).
   */
  onConfirm: _propTypes["default"].func,
  /**
   * A callback for when the mask of the dialog is clicked. This is useful if you'd like to close the dialog when a user clicks on the mask.
   */
  onMaskClick: _propTypes["default"].func,
  /**
   * A boolean letting you disable buttons entirely.
   */
  renderButtons: _propTypes["default"].bool,
  /**
   * A boolean allowing you to enable a close button in the top right corner of the dialog. This will inherit the `onCancel` behavior. Note that without an image, you may want to add some padding above your first bit of content.
   */
  renderCloseButton: _propTypes["default"].bool,
  /**
   * Props for the root container. This surrounds the dialog, and the mask.
   */
  rootContainerProps: _propTypes["default"].object
} : {};
var _default = exports["default"] = Dialog;